// TableSettingsDropdown.jsx — page-size + column-visibility cog menu.
import React from "react";
import { Dropdown, Form, Button } from "react-bootstrap";
import { FaCog } from "react-icons/fa";

const PAGE_SIZES = [10, 20, 50];

const TableSettingsDropdown = ({
   showDropdown, handleToggleDropdown, tempPageSize, handlePageSizeChange,
   columns, tempColumnVisibility, handleColumnVisibilityChange, handleApplyChanges, handleCancelChanges,
}) => {
   return (
      <Dropdown show={showDropdown} onToggle={handleToggleDropdown} align="end">
         <Dropdown.Toggle as="span" variant="link" id="dropdown-table-columns" style={{ cursor: "pointer" }}>
            <FaCog />
         </Dropdown.Toggle>
         <Dropdown.Menu
            className="dropdown-table-columns-width"
            onClick={(e) => e.stopPropagation()}
            renderOnMount
            popperConfig={{ strategy: "fixed" }}
         >
            <Dropdown.Header>Rows</Dropdown.Header>
            {PAGE_SIZES.map((size) => (
               <div className="dropdown-item" key={size}>
                  <Form.Check
                     type="checkbox"
                     label={String(size)}
                     checked={tempPageSize === size}
                     onChange={(e) => { e.stopPropagation(); handlePageSizeChange(size); }}
                  />
               </div>
            ))}
            <Dropdown.Divider />
            <Dropdown.Header>View Columns</Dropdown.Header>
            {columns
               .filter((c) => !c.excludeFromDropdown)
               .map((c) => (
                  <div className="dropdown-item" key={c.field}>
                     <div className="form-check">
                        <input
                           type="checkbox"
                           className="form-check-input"
                           checked={tempColumnVisibility?.[c.field] ?? true}
                           onChange={(e) => { e.stopPropagation(); handleColumnVisibilityChange(c.field); }}
                           id={`column-visibility-${c.field}`}
                        />
                        <label className="form-check-label" htmlFor={`column-visibility-${c.field}`}>
                           {c.label}
                        </label>
                     </div>
                  </div>
               ))}
            <Dropdown.Divider />
            <div className="d-flex justify-content-center p-2">
               <Button variant="secondary" size="sm" onClick={handleCancelChanges}>Cancel</Button>
               <Button variant="primary" size="sm" onClick={handleApplyChanges} className="ms-2">Apply</Button>
            </div>
         </Dropdown.Menu>
      </Dropdown>
   );
};
export default TableSettingsDropdown;
